var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebForms = function SvgWebForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "web-forms_svg2__a",
    x1: -8.1,
    x2: 163,
    y1: 158.58,
    y2: 2.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__b",
    x1: 6.35,
    x2: 177.46,
    y1: 174.44,
    y2: 18.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__c",
    x1: 20.8,
    x2: 191.91,
    y1: 190.31,
    y2: 34.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__d",
    x1: 30.14,
    x2: 201.24,
    y1: 200.56,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__e",
    x1: -30.78,
    x2: 140.33,
    y1: 133.69,
    y2: -22.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__f",
    x1: -16.32,
    x2: 154.78,
    y1: 149.55,
    y2: -6.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__g",
    x1: -1.87,
    x2: 169.24,
    y1: 165.42,
    y2: 9.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__h",
    x1: 12.58,
    x2: 183.69,
    y1: 181.29,
    y2: 25.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__i",
    x1: 67.44,
    x2: 238.55,
    y1: 241.51,
    y2: 85.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web-forms_svg2__a",
    id: "web-forms_svg2__j",
    x1: 7.27,
    x2: 178.38,
    y1: 175.45,
    y2: 19.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 67.74h61.29c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23",
    style: {
      fill: "url(#web-forms_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 96.77h61.29c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 125.81h61.29c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23 148.39H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23h38.71c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 54.84h-12.9c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.9h-6.45v-6.45h6.45z",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 83.87h-12.9c-1.78 0-3.23 1.44-3.23 3.23V100c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23V87.1c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.9h-6.45v-6.45h6.45z",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 112.9h-12.9c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.91h-6.45v-6.45h6.45z",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 141.94h-12.9c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.9h-6.45v-6.45h6.45z",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7 149.41a3.224 3.224 0 0 0-4.56-.08l-20.3 20.3-10.62-10.62a3.22 3.22 0 0 0-4.48 0 3.224 3.224 0 0 0-.08 4.56l12.9 12.9c.6.6 1.43.94 2.28.95.86 0 1.68-.34 2.28-.95l22.58-22.58a3.22 3.22 0 0 0 0-4.48",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.29 129.18V45.16c0-.17-.02-.34-.04-.51 0-.04 0-.08-.02-.11 0-.05-.02-.1-.04-.14-.01-.05-.02-.11-.04-.16a.5.5 0 0 0-.04-.11c-.02-.06-.04-.13-.07-.19a.3.3 0 0 0-.04-.08c-.03-.07-.06-.14-.1-.21-.01-.02-.03-.05-.04-.07-.04-.07-.08-.13-.12-.2-.02-.04-.05-.07-.08-.1-.04-.05-.07-.1-.11-.15-.07-.08-.14-.16-.22-.24L118.41.95c-.6-.6-1.43-.94-2.28-.95H9.68C7.9 0 6.45 1.44 6.45 3.23v193.55c0 1.78 1.44 3.23 3.23 3.23h148.39c19.59-.02 35.46-15.9 35.48-35.48 0-18.51-14.17-33.71-32.26-35.34Zm-11.01-87.24h-30.92V11.01l30.92 30.92ZM12.9 193.55V6.45h100v38.71c0 1.78 1.44 3.23 3.23 3.23h38.71v80.79c-18.09 1.63-32.26 16.83-32.26 35.34 0 12 5.96 22.61 15.08 29.03zm145.16 0c-16.03 0-29.03-13-29.03-29.03s13-29.03 29.03-29.03c16.03.02 29.01 13.01 29.03 29.03 0 16.03-13 29.03-29.03 29.03",
    style: {
      strokeWidth: 0,
      fill: "url(#web-forms_svg2__j)"
    }
  }));
};
export default SvgWebForms;